import React from 'react';
import ImgCard from 'component/imgCard'
import ProCard from 'component/proCard'
import { WhiteSpace,Flex,Toast,ListView,PullToRefresh} from 'antd-mobile';
import history from 'common/history'
import './index.css'

 
const PlaceHolder = ({ className = '',data = '', ...restProps }) => (
  <div className={`${className} `} {...restProps}>
   <ProCard data={data} />
  </div>
); 

class Lists extends React.Component{
    constructor(props){
      super(props);
      const dataSource = new ListView.DataSource({
        rowHasChanged: (row1, row2) => row1 !== row2,
      });
     this.state={
        dataSource: dataSource.cloneWithRows([]),
        isLoading: true,
        page:this.props.page,
        refreshing: true,
        imageStatus: null
    }
  }
  // componentDidMount() {
     
  //  setTimeout(() => {
  //         let data = ''
  //         if(this.props.data){
  //           data = this.props.data  || '';
  //         }
  //         this.setState({
  //           dataSource: this.state.dataSource.cloneWithRows(data),
  //           isLoading: false,
  //            page:1,
  //         });
  //       }, 600);
  // }
 
  componentWillReceiveProps(nextProps) { 
    this.mounted = true;
    this.getData(nextProps.data); 
    // if (nextProps.data !== this.props.data) {
      // setTimeout(() => { 
      //   let data = ''
      //   if(nextProps.data){
      //     data = nextProps.data || '';
      //   }
      //  this.setState({
      //     dataSource: this.state.dataSource.cloneWithRows(data),
      //     isLoading: false,
      //     refreshing: false,
      //   }); 
      //  }, 600);
  //  }
   }
getData(nextProps_data){
    // setTimeout(() => { 
        let data = ''
        if(nextProps_data){
          data = nextProps_data || '';
        }
       this.setState({
          dataSource: this.state.dataSource.cloneWithRows(data),
          isLoading: false,
          refreshing: false,
        }); 
       // }, 600);
}
 
componentWillUnmount() {
    this.mounted = false;
}
//分页
  paging(page){ 
     this.props.getData(page)
  }
//到底加载 
  onEndReached = (event) => { 
    const {page} = this.props
    if(this.state.page>this.props.totalPage){
    
      this.setState({
         isLoading: false,
        });     
     }else{
      this.setState((state)=>{return {
        isLoading: true ,
        page:state.page+1}
      });

      setTimeout(() => {
          this.paging(this.state.page);
        this.setState({
          isLoading: false
        });
      }, 600);
    }
    if (this.state.isLoading && !this.state.hasMore) {
      return;
    }
  }
//下拉刷新
  onRefresh = () => { 
    this.props.clear();
    this.setState({
      refreshing: true,
      isLoading: true
    });

    this.paging(1)
    setTimeout(() => {
      this.setState({
        refreshing: false,
        isLoading: false,
        page:1
      });
    }, 600);
  };

 
 
 
  render(){
    const {List,data}=this.props;
    const row = (item,index) => { 
        return (  
                 <PlaceHolder className={item.status===0?'inline-item':'none-item'} key={index} data={item}  />
                )  
      }

    return ( 
        <ListView
            style={{
              height: document.documentElement.clientHeight-100,
              overflow: 'auto',
            }}
            dataSource={this.state.dataSource}
            renderFooter={() => (<div style={{padding: 10, textAlign: 'center'}}>
              {this.state.isLoading ? '加载中' : '加载完成'}
            </div>)}
            renderRow={row}
            enableEmptySections={true}
            onEndReachedThreshold={10}
            onEndReached={this.onEndReached}
            pullToRefresh = {
            <PullToRefresh
                  refreshing={this.state.refreshing}
                  onRefresh={this.onRefresh}
                />
             }
        /> 
         
      )
  }
}
 
 
export default  Lists ;